import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { NoMediaCollected } from '../../svgs';

import styles from './VpNoMediaCollected.module.less';

export const VpNoMediaCollected = () => {
  return (
    <Box className={styles.vpNoMediaCollected}>
      <NoMediaCollected width="150px" />
      <Box>
        <Typography variant="h5">No Media Collected</Typography>
        <Typography variant="subtitle2">
          Start collecting media by adding video or attachment requests to your campaigns.{' '}
        </Typography>
      </Box>
    </Box>
  );
};

export default VpNoMediaCollected;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpNoMediaCollected/VpNoMediaCollected.jsx